var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"o-input"},[_c('span',{staticClass:"o-input-prepend"},[_vm._t("prepend")],2),_c('input',{style:({paddingLeft:_vm.labelWidth}),attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []

export { render, staticRenderFns }